import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Reportes from "./Reportes";
import ReportState from "../components/ReportState"; // 👈 NUEVO

const API = process.env.REACT_APP_API_URL;

function Informes({ modoResumen = false }) {

  const { codigo } = useParams();

  const [reporte, setReporte] = useState(null);

  useEffect(() => {

    const cargar = async () => {

      try {

        const endpoint = modoResumen
          ? `${API}/api/report/resumen-publico/${codigo}`
          : `${API}/api/report/publico/${codigo}`;

        const res = await axios.get(
          endpoint
        );

        setReporte({
          ...res.data.report,

          detalle:
            res.data.detalle ||
            res.data.report?.detalle || {
              afiliacion: [],
              creditos: [],
              creditosFull: [],
              beneficios: []
            }
        });

      } catch (err) {

        console.error(err);
        setReporte("error");

      }

    };

    cargar();

  }, [codigo]);

  if (reporte === "error") {
    return <ReportState type="error" />;
  }

  if (!reporte) {
    return <ReportState type="loading" />;
  }

  return (
    <Reportes
      reporteExterno={reporte}
      modoPublico={true}
      modoResumen={modoResumen}
    />
  );

}

export default Informes;